import { Component, Inject, OnInit } from '@angular/core';
import { FormValidator } from './form.validator';
import { LoginService } from './login/login.service';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { BrandService } from './brand/brand.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [FormValidator, LoginService]
})
export class AppComponent {

  routingEnable = true;
  registrationEnable = false;

  newLogin = false;

  newRegistration = false;
  subDomain: string
  constructor(@Inject(DOCUMENT) private document: any, private loginservice: LoginService, private router: Router,
  private translate: TranslateService, private brandService: BrandService) {
    this.brandService.apply();
    const getUrl = this.document.location.href;
    const schoolDomain = document.cookie.split(';').find(cookie => cookie.trim().startsWith('schoolDomain='));
    let schoolDomainValue = schoolDomain ? schoolDomain.split('=')[1] : null;
    // A cookie previously written from a nullish value would literally read
    // back as the strings "null"/"undefined" — treat those the same as "not
    // set" rather than as a real (bogus) school domain.
    if (schoolDomainValue === 'null' || schoolDomainValue === 'undefined' || schoolDomainValue === '') {
      schoolDomainValue = null;
    }
    this.subDomain = schoolDomainValue
    const full = window.location.host;

    // window.location.host is sub-domain.domain.com
    const parts = full.split('.');
    const sub = parts[0];
    const domain = parts[1];
    const type = parts[2];

    if (['register'].indexOf(sub) !== -1 || getUrl === 'http://localhost:4200/' ||
      getUrl === 'http://127.0.0.1/angular%20app/BW_WebAppBuild/'  ||
      getUrl === 'http://www.old-registration.bluewings.in/' || getUrl === 'http://localhost:4200' ||
      getUrl === 'http://127.0.0.1/angular%20app/BW_WebAppBuild'  || getUrl === 'http://35.163.2.57/' ||
      getUrl === 'http://35.163.2.57' || getUrl === 'https://register.bluewings.in/' ||
      getUrl === 'https://register.bluewings.in') {
      const pathArr = full.split('/');
      if (pathArr[pathArr.length - 1] === '') {
        this.routingEnable = true;
        this.registrationEnable = false;
        this.newRegistration = false;
      } else {
        this.routingEnable = false;
        this.registrationEnable = true;
        this.newRegistration = false;
      }
    }
    else if (['app', "dev-app"].indexOf(sub) !== -1) {
      this.routingEnable = false;
      this.newLogin = true;
    }
    else if (['registration', "dev-registration"].indexOf(sub) !== -1) {
      this.routingEnable = false;
      this.registrationEnable = false;
      this.newRegistration = true;
    }
    else if (['parent', "dev-parent"].indexOf(sub) !== -1) {
      // Parent portal has its own login/dashboard/diary routes, guarded by
      // parentAuthGuard/parentHomeRedirectGuard (parent-auth.guard.ts) —
      // deliberately separate from admin/staffGuard — instead of a single
      // flat component render like app./registration. use.
      this.routingEnable = true;
    }
    let currentPath = window.location.hash;
    currentPath = currentPath.charAt(0) === '#' ? currentPath.substr(1, currentPath.length) : currentPath;
    if (domain !== undefined) {
      if (['register'].indexOf(sub) !== -1) {
        this.routingEnable = false;
        this.registrationEnable = true;
      } else if (['parent', 'dev-parent'].indexOf(sub) !== -1) {
        // "parent" is a fixed route prefix (like app./registration.), not a
        // school subdomain — validateDomain() below checks whether `sub` is
        // a real registered school domain, which "parent" never is, so skip
        // it here the same way the 'register' branch does. The bare-root
        // case (parent.<domainSuffix>/ with no path) is handled by
        // parentHomeRedirectGuard on the "" route instead.
      } else {
        if (!this.subDomain) {
          const domainSuffix = this.brandService.brand.domainSuffix || window.location.hostname.split('.').slice(1).join('.');
          this.loginservice.validateDomain(sub, domainSuffix)
            .subscribe(
              (data: any) => {
                if (data.errorcode === 10010 || data.errorcode === 10036) {
                  this.router.navigate(['/suspended']);
                } else if (data.errorcode !== undefined) {
                  // for testing server
                  const domainSuffix = this.brandService.brand.domainSuffix || window.location.hostname.split('.').slice(1).join('.');
                  location.href = `https://registration.${domainSuffix}`;
                } else {
                  this.router.navigate([currentPath]);
                }
              },
              error => console.log(error),
              () => {
              }
            );
        }

      }
    }
    const urlSubDomain = window.location.hostname.split('.')[0];
    const protocol = window.location.protocol + "//";
    // A leftover schoolDomain cookie from an earlier admin/staff session
    // (on a different subdomain, in the same browser) would otherwise
    // force-redirect parent.<domainSuffix> away to that stored subdomain —
    // parents aren't tied to one school's cookie the way admin/staff
    // sessions are, so this redirect must never apply to the parent portal.
    if (this.subDomain && urlSubDomain !== this.subDomain && this.brandService.brand.domainSuffix
      && ['parent', 'dev-parent'].indexOf(urlSubDomain) === -1) {
      window.location.href = `${protocol}${this.subDomain}.${this.brandService.brand.domainSuffix}${window.location.pathname}${window.location.hash}`
    }
    const savedLang = localStorage.getItem('lang') || 'en';
    translate.setDefaultLang(savedLang);
    translate.use(savedLang);
  }

}